import { Box, Typography } from '@material-ui/core'

import { getSegmentValue } from 'components/SegmentSelector/segment-service'

import { withContext } from '../Context'
import CheckList from '../components/CheckList'

const SegmentName = 'Race'

const RACE_OPTIONS = [
  'American Indian or Alaska Native',
  'Asian',
  'Black or African American',
  'Native Hawaiian or Other Pacific Islander',
  'White',
]

export const RaceSelector = ({
  criteria = 'Must',
  segment,
  onChange,
}: {
  criteria: string
  onChange: (criteria: string, segmentName: string, value: any, operation?: string) => void
  segment: object
}) => {
  const currentValues = getSegmentValue(segment, criteria, SegmentName)
  return (
    <Box>
      <Box pb={1}>
        <Typography
          variant="subtitle2"
          color="textPrimary"
          className="title"
        >
          Race
        </Typography>
      </Box>
      <CheckList
        selectedValues={currentValues}
        values={RACE_OPTIONS}
        labels={RACE_OPTIONS}
        onChange={(values) => onChange(criteria, SegmentName, values, 'contains')}
      />
    </Box>
  )
}

export default withContext(RaceSelector)
